module.exports = __webpack_public_path__ + "static/Vu-Nguyen-d66d65bd1032b8232d85119d48649ea6.jpg";